<template>
    <div class="managerContact">
        <div class="managerMenu">
            <q-tabs v-model="managerDashboardTabs" class="q-px-container text-white" active-class="activeTab" align="left" no-caps>
                <q-route-tab :to="{ name: 'ManagerHome' }" name="dashboard" :ripple="false" label="Home" exact />
                <q-route-tab :to="{ name: 'ManagerInbox' }" name="inbox" :ripple="false" label="Messages" exact />
                <q-route-tab :to="{ name: 'ManagerReservation' }" name="my-reservation" :ripple="false" label="Reservations" exact />
                <q-route-tab :to="{ name: 'ManagerDeals' }" name="gogo-deals" :ripple="false" label="GoGo Deals" exact />
                <q-route-tab :to="{ name: 'ManagerProfile' }" name="profile" :ripple="false" label="Profile" exact />
                <q-route-tab :to="{ name: 'ManagerAccount' }" name="account" :ripple="false" label="Account" exact />
                <q-route-tab :to="{ name: 'ManagerHelp' }" name="help" :ripple="false" label="Help" exact />
            </q-tabs>
        </div>
        <div class="managerLayout contactForm q-px-container row justify-center">
            <div class="col-12 col-sm-7">
                <div class="stepTitle">Contact Us</div>
                <div class="formContainer">
                    <q-form ref="contactFromRef" @submit="sendContactDetails" @reset="resetForm">
                        <div class="row">
                            <div class="col-12 col-sm-6 inputField">
                                <div class="fieldLabel">Name<span class="text-red-8">*</span></div>
                                <q-input ref="nameRef" v-model.trim="name" placeholder="Your Name" dense outlined hide-bottom-space :rules="[val => customValidations.generalValidation(val, 'a Name')]" />
                            </div>
                            <div class="col-12 col-sm-6 inputField">
                                <div class="fieldLabel">Email<span class="text-red-8">*</span></div>
                                <q-input ref="emailRef" v-model.trim="email" placeholder="Your Email Address" dense outlined hide-bottom-space :rules="[val => customValidations.emailValidation(val)]" />
                            </div>
                        </div>
                        <div class="inputField">
                            <div class="fieldLabel">Message<span class="text-red-8">*</span></div>
                            <q-input
                                ref="messageRef"
                                v-model.trim="message"
                                type="textarea"
                                placeholder="Message..."
                                dense
                                hide-bottom-space
                                outlined
                                rows="10"
                                :rules="[val => !!val || 'Please enter a Message.']" />
                        </div>
                        <div class="captchaField">
                            <vue-recaptcha ref="recaptchaRef" :sitekey="recaptchaKey" @verify="captchaResponse" @expired="captchToken = null" />
                        </div>
                        <q-btn label="Send" type="submit" class="sendBtn btn btn--no-hover" :class="{ 'full-width': $q.screen.lt.sm }" :disable="!captchToken" dense no-caps />
                    </q-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import _ from 'lodash';

export default {
    components: { VueRecaptcha },
    data() {
        return {
            name: null,
            email: null,
            message: null,
            recaptchaKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            captchToken: null,
            captchaError: true,
            managerDashboardTabs: 'dashboard',
        };
    },
    watch: {
        name(newVal) {
            if (newVal) this.name = this.customValidations.allowOneSpace(newVal);
        },
        message(newVal) {
            if (newVal) this.message = this.customValidations.allowOneSpace(newVal);
        },
    },
    methods: {
        captchaResponse(event) {
            this.captchToken = event;
        },
        resetForm() {
            this.name = null;
            this.email = null;
            this.message = null;

            this.$refs.nameRef.resetValidation();
            this.$refs.emailRef.resetValidation();
            this.$refs.messageRef.resetValidation();
        },
        sendContactDetails() {
            this.axios.post('/api/v1/property-manager/contact-us', {
                userId: _.get(this.$store, 'state.storeUserDetails.userData.user_id'),
                isApi: true,
                name: this.name,
                email: this.email,
                feedback: this.message,
                recaptchaResponse: this.captchToken,
            }).then((response) => {
                this.$refs.contactFromRef.reset();
                this.$refs.recaptchaRef.reset();
                this.$q.notify({
                    icon: 'check_circle', color: 'black', position: 'bottom', message: response.data.message,
                });
            }).catch((error) => {
                if (error.response.data.errors) {
                    const msg = Object.values(error.response.data.errors)[0];
                    this.$q.notify({
                        icon: 'cancel', color: 'black', position: 'bottom', message: msg,
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.managerMenu {
    background: #666;

    .q-tab {
        margin-right: 1.25rem;
        padding: unset;
        min-height: 2.562rem;
        opacity: 1;
        transition: none;
        color: #999;

        &:hover,
        &.activeTab {
            color: #fff;
        }

        :deep(.q-focus-helper) {
            visibility: hidden;
        }

        :deep(.q-tab__indicator) {
            height: 0.25rem;
        }
    }
}

.contactForm {
    margin: 3rem auto;

    .formContainer {
        padding: 1.25rem;
        border: 1px solid #00000020
    }

    .inputField {
        margin-bottom: 1rem;
        padding: 0 .25rem;

        .fieldLabel {
            margin-bottom: .5rem;
            font-size: .875rem;
        }
    }

    .captchaField {
        margin-bottom: 1rem;
        padding-left: .25rem;
    }

    .sendBtn {
        margin-left: .25rem;
        min-width: 15rem;
        font-size: 1rem;
    }
}

@media only screen and (max-width: $breakpoint-xs) {
    .managerMenu .q-tab {
        min-height: 2.187rem;
        margin-right: 0.25rem;

        :deep(.q-tab__label) {
            font-size: 0.625rem;
        }
    }

    .contactForm {
        margin: 1.5rem auto;
    }
}
</style>
